import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { concatMap, withLatestFrom, delay } from 'rxjs/operators';
import { Action } from 'redux';
import { push } from 'connected-react-router';
import { PublishReleaseSuccess } from '../action-creators';
import { PUBLISH_RELEASE_SUCCESS } from '../actions';
import { UpdateAchievement } from '@webapp/store/artist/action-creators';
import AppState from '../../state';
import { GetCatalog } from '@webapp/store/catalog/action-creators';

export const publicReleaseSuccessEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, PublishReleaseSuccess>(PUBLISH_RELEASE_SUCCESS),
    withLatestFrom(state$),
    delay(3000),
    concatMap(([action, state]) => {
      localStorage.removeItem('Trac.PayAsYouGo');

      if (action.allArtists.filter((a) => !a.externalIds?.spotify).length) {
        let path = [
          '',
          'release',
          action.artistId,
          action.releaseId,
          'streaming-platforms',
        ];
        return [push(path.join('/'))];
      }
      const actions: Action[] = [new GetCatalog(), push('/catalog')];

      if (state.artist.active) {
        let id = state.artist.achievements.find(
          (val) => val.achievementKey === 'first-release'
        )?.id;
        if (!state.artist.active.achievements?.includes(id || '')) {
          if (id) {
            actions.push(
              new UpdateAchievement(state.artist.active.id, id as string)
            );
          }
        }
      }
      return actions;
    })
  );
